import type { SessionStorageItemEnum } from "@/utils/enums/SessionStorageItemEnum";

export function getSessionStorageItem(item: SessionStorageItemEnum) {
  if (typeof sessionStorage === "undefined") return "";
  return sessionStorage.getItem(item);
}

export function setSessionStorageItem(
  item: SessionStorageItemEnum,
  value: any,
) {
  if (typeof sessionStorage !== "undefined") {
    sessionStorage.setItem(item, value);
  }
}
export function removeSession(item: SessionStorageItemEnum) {
  if (typeof sessionStorage !== "undefined") {
    sessionStorage.removeItem(item);
  }
}
